module.exports = __webpack_public_path__ + "static/media/logo.473f7c74.svg";